module.exports = __webpack_public_path__ + "static/media/wa.18e84061.png";